import { render, staticRenderFns } from "./ServiceOrdersRequestedByMonth.vue?vue&type=template&id=7066a75e"
import script from "./ServiceOrdersRequestedByMonth.vue?vue&type=script&lang=js"
export * from "./ServiceOrdersRequestedByMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports